package com.vamvisions.main.contact.di

import com.vamvisions.main.contact.data.remote.ContactApi
import com.vamvisions.main.contact.data.repository.RemoteContactRepository
import com.vamvisions.main.contact.domain.repository.ContactRepository
import com.vamvisions.main.contact.presentation.ContactViewModel
import org.koin.core.module.dsl.bind
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

/** [ContactViewModel] is a factory for the same reason as in `corePresentationModule`. */
val contactModule = module {
    singleOf(::ContactApi)
    singleOf(::RemoteContactRepository) { bind<ContactRepository>() }
    factoryOf(::ContactViewModel)
}
